import {EntityStore, StoreConfig} from "@datorama/akita";
import {LeagueEventsState} from "./models";

@StoreConfig({name: 'leagueevent', resettable: true})
export class LeagueEventStore extends EntityStore<LeagueEventsState> {
}